import arabicTranslations from './arabicTranslations';

export const instructions = `# 🌟 Intelligent Cancer Genomics Navigator (iCGN) - User Guide 🌟

Welcome to iCGN, your advanced tool for creating and analyzing cancer pedigrees, developed by the Artificial Intelligence and Data Innovation (AIDI) office at King Hussein Cancer Center.

## 🚀 Getting Started

1. **➕ Adding Family Members**: Click the "Add Parent", "Add Child", or "Add Spouse" buttons to add new family members to the pedigree.

2. **📝 Entering Information**: 
   - Fill in the details for each family member in the form provided.
   - For multiple cancer types, separate them with commas in the "Cancer(s)" field (e.g., "Breast, Ovarian").

3. **❌ Deleting Family Members**: Click the "Delete" button in a family member's form to remove them from the pedigree.

## 🖼️ Navigation and Visualization

1. **🖱️ Moving the Canvas**: Click and drag on the canvas to pan and view different parts of the pedigree.

2. **🔍 Zooming**: Use the "Zoom In" and "Zoom Out" buttons to adjust the view.

3. **✨ Highlighting**: Click on a family member's form or node to highlight it on the canvas.

4. **👁️ Showing/Hiding Footnotes**: Toggle the "Show/Hide" button to display or hide additional information on the canvas.

## 💾 Saving and Loading

1. **📄 Save as PDF**: Click the "PDF" button to save the current pedigree view as a PDF file.

2. **📊 Save as CSV**: Click the "CSV" button to export the pedigree data as a CSV file.

3. **📥 Load from CSV**: Click the "Load" button to import a previously saved CSV file.

## 🤖 AI Assistance

1. **🧠 Using AIDI**: Click the "AIDI" button to get AI-powered insights and suggestions based on the current pedigree.

## 🔄 Additional Features

1. **🔄 Reset Canvas**: Click the "Reset" button to clear the current pedigree and start over.

2. **ℹ️ About iCGN**: Click the "About iCGN" link to learn more about the application and its features.

## 📧 Support and Feedback

For any questions, support, or feedback, please email AIDI@khcc.jo.

---

Developed by the Artificial Intelligence and Data Innovation (AIDI) office at King Hussein Cancer Center. All rights reserved.`;
